import { getEnvVar } from 'utility/env';
import { UserRoles } from 'types';

const getBaseURL = (): string => {
  switch (getEnvVar('ENVIRONMENT')) {
    case 'development':
      return getEnvVar('DEVELOPMENT_API_URL')!;
    case 'staging':
      return getEnvVar('STAGING_API_URL')!;
    case 'production':
      return getEnvVar('PRODUCTION_API_URL')!;
    case 'demo':
      return getEnvVar('PRODUCTION_API_URL')!;
    default:
      return getEnvVar('DEVELOPMENT_API_URL')!;
  }
};

export const baseURL = getBaseURL();

export const Endpoints = {
  'Internal Messages': '/internal-message',
  'Service SMS': '/service-sms',
  [UserRoles.PARTS_ADVISOR]: 'users',
  [UserRoles.SALES_AGENT]: 'users',
  [UserRoles.SALES_MANAGER]: 'users',
  [UserRoles.SERVICE_ADVISOR]: 'users',
  [UserRoles.SERVICE_MANAGER]: 'users',
  [UserRoles.TECHNICIAN]: 'users',
  advisorDashboard: '/dashboard/advisor',
  advisorRecommendationReport: '/reporting/advisor-recommendation',
  advisorReport: '/reporting/user-metrics',
  advisorUsageReport: '/reporting/advisors-usage',
  advisorUsageReportV2: '/reporting/advisor-usage-v2',
  advisorUsageReportForRVIndustry: '/reporting/user-metrics',
  appointment: '/appointment',
  appointmentAvailability: '/appointment-availability',
  appointmentCodeGroup: '/appointment-code-group',
  appointmentCodeopCode: '/appointment-code-operation-code',
  appointmentCodes: '/appointment-code',
  appointmentCodeSortOrder: '/appointment-code/sort-order',
  appointmentGroupSortOrder: '/appointment-code-group/sort-order',
  appointmentSearchByVinImage: '/appointment/search-by-vin-image',
  authentication: '/authentication/authenticate',
  checkIn: '/checkin',
  mfaVerify: '/authentication/mfa/verify',
  command: '/command',
  confirmQuote: '/repair-order-quote/confirm',
  coupons: '/coupons',
  currentUser: '/users/current',
  customerByDmsId: '/customer/find-by-dms-id',
  customerEngagementReport: '/reporting/customer-engagements',
  customerEngagementReportForRVIndustry: '/reporting/user-metrics',
  customerNote: '/customer-note',
  customerPhoto: '/customer-photo',
  customers: '/customer',
  customerVehicle: '/customer-vehicle',
  dealershipPackages: '/dealership-package',
  dealershipPackageOperationCode: '/dealership-package-operation-code',
  dealershipPackageSortOrder: '/dealership-package/sort-order',
  declinedServiceReport: '/reporting/repair-order-quote',
  deferrals: '/deferrals',
  demo: '/demo',
  esignDocument: '/esign-document',
  factoryMaintenanceAnalyzeSwap: '/factory-maintenance/analyze-swap',
  fluidPricing: '/fluid-pricing',
  factoryMaintenanceMenu: '/factory-maintenance-menu',
  factoryMaintenanceMenuByVin: '/factory-maintenance-menu/by-vin',
  motorResolveVin: 'motor/vehicle/resolve-vin',
  factoryMaintenanceSchedules: '/factory-maintenance-schedules',
  followUpReporting: '/repair-order',
  followUpTargets: 'follow-up/targets',
  internalMessage: '/internal-message',
  internalSignoff: '/internal-signoff',
  iPayReport: '/repair-order-payment',
  kbbMake: '/kbb/kbb-make',
  kbbModel: '/kbb/kbb-model',
  kbbYear: '/kbb/kbb-year',
  laborRateDmsCodes: '/labor-rate/dms-codes',
  laborRateMatrix: '/labor-rate-matrix',
  laborRates: '/labor-rate',
  licensePlateLookup: '/carfax/license-plate-lookup',
  lightyearFinanceInvoiceById: '/dms/deal-by-number',
  lightyearPartsInvoiceById: '/dms/part-invoice-by-number',
  lightyearSignableDocument: '/dms/signable-document',
  localConfig: '/settings/local-config',
  localConfigValue: '/settings/local-config/value',
  productFruitsConfig: '/settings/product-fruits-config',
  mobileCheckinReport: '/reporting/mobile-check-in',
  videoReachReport: '/reporting/video-reach',
  videoTroubleshootingReport: '/reporting/video-troubleshooting',
  motorDotComBaseVehicleDetails: 'motor/vehicle/base-vehicle-details',
  motorDotComEngines: 'motor/vehicle/engines',
  motorDotComLaborEstimates: 'motor/estimated-work-times',
  motorDotComLaborGroups: 'motor/estimated-work-times/groups',
  motorDotComLaborSubGroups: 'motor/estimated-work-times/sub-groups',
  motorDotComLaborSystems: 'motor/estimated-work-times/systems',
  motorDotComMakes: 'motor/vehicle/makes',
  motorDotComModels: 'motor/vehicle/models',
  motorDotComParts: 'motor/parts',
  motorDotComPartsGroups: 'motor/parts/groups',
  motorDotComPartsSubGroups: 'motor/parts/sub-groups',
  motorDotComPartsSystems: 'motor/parts/systems',
  motorDotComVinSearch: 'motor/vehicle/by-vin',
  motorDotComYears: 'motor/vehicle/years',
  mpi: '/repair-order-mpi',
  mPIGroup: 'mpi-group',
  mPIItem: 'mpi-item',
  mpiItemOpCode: '/mpi-item-operation-code',
  mpiReport: '/reporting/mpi',
  mpiTemplates: 'mpi-template',
  myReviewAdvisorReport: 'myReview/advisor-reports',
  opCodes: 'operation-code',
  opCodesCharges: '/operation-code-quote-misc-charge/',
  opCodesDiscounts: '/operation-code-quote-discount/',
  opCodeSkillLevels: '/operation-code/skill-levels',
  overviewReport: '/reporting/trend',
  partMatrices: 'part-matrix-collection',
  partMatrix: 'part-matrix',
  partMatrixCollection: 'part-matrix-collection',
  partMatrixValue: 'part-matrix-value',
  parts: '/parts',
  partsExpress: '/parts-express',
  partsExpressCompleteTask: '/parts-express-task/complete',
  partsExpressStartTask: '/parts-express-task/start',
  partsExpressStartTaskAdditionalProcessing: 'parts-express-task/start/additional-processing',
  partsExpressTasks: '/parts-express-task',
  partsPickList: 'repair-order-pick-list-part',
  partsPrice: '/parts/price',
  partsReporting: '/parts-reporting',
  partsSourceLaborRateMatrix: 'part-source/labor-rate-matrix',
  paymentMethods: '/dms/payment-methods',
  paymentROTerminalCancel: '/repair-order-payment/terminal-cancel',
  paymentROTerminalPay: '/repair-order-payment/terminal-pay',
  paymentROTerminalRefund: '/repair-order-payment/terminal-refund',
  paymentSavedCards: '/payment-saved-card',
  paymentsNonRO: '/payment',
  paymentsRO: '/repair-order-payment',
  paymentsSales: '/payment',
  paymentTerminal: '/payment-terminal',
  paymentTerminalCancel: '/payment/terminal-cancel',
  paymentTerminalPay: '/payment/terminal-pay',
  paymentTerminalRefund: '/payment/terminal-refund',
  pointsAward: '/points/award',
  pointsRedeem: '/points/redeem',
  priceMatrix: '/price-matrix',
  quote: '/repair-order-quote',
  quoteBadgeCount: '/dashboard/advisor/quote-badge-count',
  quoteComplete: '/repair-order-quote/complete',
  quoteDiscounts: '/quote-discount',
  quoteInProgress: '/repair-order/quote-in-progress',
  quoteMiscCharges: '/quote-misc-charge',
  quotePullRecommendations: '/repair-order-quote/pull-recommendations',
  quotePushRecommendations: '/repair-order-quote/push-recommendations',
  quoteRecommendation: '/repair-order-quote-recommendation',
  quoteRecommendationParts: '/repair-order-quote-recommendation-part',
  quoteRecommendationSortOrder: '/repair-order-quote-recommendation/sort-order',
  recalls: '/recalls',
  recommendationReport: '/reporting/recommendation',
  reconditioningExpress: '/reconditioning-express',
  reconditioningPhase: '/reconditioning-phase',
  reconditioningPhaseCycleTime: '/reporting/reconditioning-phase-cycle-time',
  reconditioningPhaseSortOrder: '/reconditioning-phase/sort-order',
  reconditioningReAssign: '/reconditioning-phase/re-assign',
  reOpenRO: '/repair-order/re-open',
  repairOrderByDmsId: '/dms/repair-order-by-number',
  repairOrderChecklist: '/repair-order-checklist',
  repairOrderCustomer: '/repair-order-customer',
  repairOrderExcludedCustomer: '/repair-order-excluded-customer',
  repairOrderInteractions: '/repair-order-interactions',
  repairOrderMedia: '/repair-order-media',
  repairOrderMultiPointInspection: '/repair-order-multi-point-inspection',
  repairOrderQuote: '/repair-order-quote',
  repairOrderQuoteDiscounts: '/repair-order-quote-discount',
  repairOrderQuoteMiscCharges: '/repair-order-quote-misc-charge',
  repairOrderReconditioingPhase: '/repair-order-reconditioning-phase-interaction',
  repairOrderSearchByVinImage: '/repair-order/search-by-vin-image',
  repairOrderServicePhase: 'repair-order-service-phase-interaction',
  reportingCustomer: '/reporting/customer',
  resendWaiver: '/repair-order-waiver/re-send',
  resetPassword: '/security/reset-password',
  rewards: '/rewards',
  rewardsTier: '/rewards-tier',
  roNotes: '/repair-order-note',
  roReport: 'myReview/ro-reports',
  roReporting: '/repair-order',
  ros: '/repair-order',
  roVideo: '/repair-order-video',
  scanDocument: '/scan/document',
  scanVin: '/scan/vin',
  scheduledMaintenance: 'scheduled-maintenance',
  security: '/security',
  sendQuote: '/repair-order-quote/send',
  sendVideo: '/repair-order-video/send-all',
  serviceExpress: '/service-express',
  serviceGroup: '/service-group',
  serviceGroupCapacity: '/service-group-capacity',
  serviceLaneCapacity: '/service-lane-capacity',
  serviceOffHour: '/service-off-hour',
  servicePhase: '/service-phase',
  servicePhaseCycleTime: '/reporting/service-phase-cycle-time',
  servicePhaseReAssign: '/service-phase/re-assign',
  servicePhaseSortOrder: '/service-phase/sort-order',
  servicePhaseTrendReport: '/reporting/service-phase-trend',
  servicePhaseUserTrendReport: '/reporting/service-phase-user-trend',
  serviceQuickSMS: '/service-quick-sms',
  serviceSMSMarkRead: '/service-sms/mark-read',
  settings: '/settings',
  SMS: '/sms',
  smsMarkRead: '/sms/mark-read',
  support: '/support',
  syncEmployees: '/dms/sync-employees',
  fordHistoricalBatch: '/ford/historical-backfill',
  syncPreApprovals: '/repair-order-quote/sync-pre-approvals',
  syncQuote: '/repair-order-recommendations-sync',
  // ISA-2402 story 2.2: the one Team-options endpoint (AD-6). Every consumer of Team options
  // fetches through this key -- no component derives options from repair-order rows on screen,
  // and no component calls Lightyear directly.
  teamOptions: '/team-options',
  technicianPerformanceReport: '/reporting/technician-performance',
  technicianRecommendationReport: '/reporting/technician-recommendation',
  technicianReport: '/reporting/user-metrics',
  technicianUsageReport: '/reporting/user-metrics',
  transferQuote: '/repair-order-quote/in-progress',
  transportationType: '/transportation-type',
  traxtion: '/traxtion/scan',
  unDeleteRO: '/repair-order/un-delete',
  unreadMessageCounts: '/message/unread',
  upgrade: '/upgrade',
  upgradeReporting: '/upgrade-reporting',
  users: '/users',
  UVEye: '/uv-eye',
  validateMobilePhone: '/phone-lookup',
  vehicleHistory: '/vehicle-history',
  vehicleMakes: '/vehicle/makes',
  vehicleModels: '/vehicle/models',
  vehicleReconditioningPhaseTrendReport: '/reporting/reconditioning-phase-trend',
  vehicleReconditioningUserTrendReport: '/reporting/reconditioning-phase-user-trend',
  vehicleYears: '/vehicle/years',
} as const;
